export const scenarioLabels = {
  neutral: 'Bottom-up',
  crisis: 'Top-down',
};
